
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AvailableLoan } from '@/interfaces/loan';
import Alert from '~/components/Alerts/Alert.vue';
import applicationId from '@/filters/application-id';
import CollectionAgencyContact from '@/components/Loans/Collections/CollectionAgencyContact.vue';

@Component({ components: { CollectionAgencyContact, Alert } })
export default class CollectionAlert extends Vue {
  @Prop({ type: Object, required: true }) readonly loan!: AvailableLoan;

  showCollectionAgencyInfo = false;

  showSelf = true;

  get humanLoanNumber(): string {
    return applicationId(this.loan.loan_number);
  }

  get isActiveLoan(): boolean {
    return this.$store.getters['User/activeLoanNumber'] === this.loan.loan_number;
  }

  get hasCollectionAgencyInfo(): boolean {
    return this.loan.collection.collections_agency !== null;
  }

  get isVisible(): boolean {
    if (this.isActiveLoan) {
      return true;
    }

    return this.showSelf;
  }

  toggleInfo() {
    this.showCollectionAgencyInfo = !this.showCollectionAgencyInfo;
  }
}
